/**
 *
 * @desc 获取当前组件被渲染那一刻的menuId（菜单ID），可用来设置请求头信息等，防止在特殊场景取错菜单ID，比如代码在后台运行时取错菜单ID,
 * @export
 * @param {*} vm
 * @return {*}
 */
export function getRenderMenuId (vm) {
  const __ERP_MENU_KEY__ = '__ERP_MENU_KEY__'
  function findMenuId(component) {
    if (component && component.$vnode && component.$vnode.componentOptions) {
      try {
        const menuOptions = component.$vnode.componentOptions.Ctor.extendOptions[__ERP_MENU_KEY__]
        if (menuOptions && menuOptions.menu && menuOptions.menu.id) {
          return menuOptions.menu.id
        }
      } catch (error) {
        return null
      }
    }

    if (component && component.$parent) {
      return findMenuId(component.$parent)
    }

    return null
  }

  const menu = findMenuId(vm)

  return menu // 不取 window.__ERPMODULE__下面的id 他是不准确的，在无菜单时的虚拟菜单会使用上一次的菜单信息。
}



// WEBPACK FOOTER //
// ./src/public/utils/menu-id.js